import { architectureModalData } from '@spo/logic';
import { useQuery } from '@tanstack/react-query';
import { sleep } from '../utils/sleep';
import { useSearchedSports } from './useSports';

export const useSportsArchitectureModal = (
  searchSportInput: string,
  debounce = false,
) => {
  const { data: searchedSportsData } = useSearchedSports(
    searchSportInput,
    searchSportInput.length > 0,
  );

  return useQuery({
    queryKey: ['useSportsArchitectureModal', searchedSportsData],
    queryFn: async ({ signal }) => {
      if (debounce) {
        await sleep(500);
      }
      if (searchedSportsData && !signal?.aborted) {
        return architectureModalData.getDataSports(searchedSportsData);
      }
    },
    enabled: !!searchedSportsData && searchedSportsData.length > 0,
  });
};
